import { Box, Tooltip } from '@material-ui/core';
import { Help } from '@material-ui/icons';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { Document } from '@roc/feature-types';
import { StandardDialog, Button } from '@roc/ui';
import { useDocumentStore } from "@roc/feature-documents";
import { observer } from 'mobx-react';
import { UnderwriteTheLoan } from './underwriteTheLoan';

export type UnderwriteTheLoanDialogProps = {
  open?: boolean;
  onClose?: () => void;
  document?: Document;
};

export const UnderwriteTheLoanDialog = observer((
  props: UnderwriteTheLoanDialogProps
) => {
  const { open, onClose, document } = props;
  const taskId = document?.taskId;
  const { documentStore } = useDocumentStore();

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={open}
          title={document?.taskName}
          handleClose={onClose}
          dialogContent={<UnderwriteTheLoan loanId={document?.loanId} taskId={taskId} handleClose={onClose} />}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={open}
          title={document?.taskName}
          maxWidth="sm"
          handleClose={onClose}
          dialogContent={<UnderwriteTheLoan loanId={document?.loanId} taskId={taskId} handleClose={onClose} />}
        />
      )}
    </>
  );
});

export default UnderwriteTheLoanDialog;
